document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-brax-builder]');
  if (!root) return;
  const form = root.querySelector('#BraxBuilderForm');
  const summary = root.querySelector('[data-brax-summary]');
  const body = root.querySelector('[data-brax-body]');
  const error = root.querySelector('[data-brax-error]');
  const inputs = [...root.querySelectorAll('[data-brax-input]')];
  const outputs = [...root.querySelectorAll('[data-brax-output]')];
  const becs = [...root.querySelectorAll('[data-brax-bec]')];
  const vehicle = root.querySelector('[data-brax-vehicle]');
  const notes = root.querySelector('[data-brax-notes]');
  const priceBox = root.querySelector('[data-brax-price-box]');
  const total = root.querySelector('[data-brax-total]');
  const priceNote = root.querySelector('[data-brax-price-note]');
  const addCartButton = root.querySelector('[data-brax-add-cart]');
  const cartError = root.querySelector('[data-brax-cart-error]');
  const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  const componentPrices = Object.freeze({
    58994260443510: 32499, 58994260476278: 16999,
    58994260509046: 28499, 58994260541814: 19999,
    58994260574582: 18499, 58994260607350: 13999,
    58994260640118: 13999
  });
  let attemptedSubmit = false;

  function pricePence(el) {
    return Number(el.selectedOptions[0]?.dataset.pricePence || 0);
  }

  function selected(list, label) {
    return list.map((el, index) => `${label} ${index + 1}: ${el.value}`);
  }
  function addLine(dl, term, value) {
    const dt = document.createElement('dt');
    dt.textContent = term;
    const dd = document.createElement('dd');
    dd.textContent = value;
    dl.append(dt, dd);
  }
  function render() {
    const colour = root.querySelector('input[name="brax_colour"]:checked')?.value || 'Black';
    const activeOutputs = outputs.filter(el => el.value !== 'None').length;
    const activeInputs = inputs.filter(el => el.value !== 'None').length;
    const activeBecs = becs.filter(el => el.value !== 'None').length;
    const corePence = Number(priceBox.dataset.corePricePence);
    const inputPence = inputs.reduce((sum, el) => sum + pricePence(el), 0);
    const outputPence = outputs.reduce((sum, el) => sum + pricePence(el), 0);
    const becPence = becs.reduce((sum, el) => sum + pricePence(el), 0);
    const totalPence = corePence + inputPence + outputPence + becPence;
    const dl = document.createElement('dl');
    addLine(dl, 'CORE finish', colour);
    addLine(dl, 'Inputs', `${activeInputs} of 4 additional stereo modules selected`);
    addLine(dl, 'Outputs', `${activeOutputs} of 6 stereo modules selected`);
    addLine(dl, 'Extension cards', `${activeBecs} of 2 slots selected`);
    summary.replaceChildren(dl);
    total.textContent = gbp.format(totalPence / 100);
    priceNote.textContent = `${activeOutputs ? 'CORE and selected modules' : 'CORE only. Choose at least one output module'}. Typical build time: 10 working days after we agree the specification. Accessories are added separately.`;
    body.value = [
      'BRAX DSP bespoke build request — not an order',
      `Listed CORE + module price: ${gbp.format(totalPence / 100)}${activeOutputs ? '' : ' (incomplete: no output module)'}`,
      `Price breakdown: CORE ${gbp.format(corePence / 100)}; input modules ${gbp.format(inputPence / 100)}; output modules ${gbp.format(outputPence / 100)}; BEC cards ${gbp.format(becPence / 100)}`,
      `CORE colour: ${colour}`,
      'Integrated optical/coaxial stereo SPDIF input: included (one selectable path)',
      ...selected(inputs, 'Input'),
      ...selected(outputs, 'Output'),
      ...selected(becs, 'BEC'),
      `Vehicle/source/factory audio: ${vehicle.value.trim() || 'Not supplied'}`,
      `Amplifiers/speaker layout/notes: ${notes.value.trim() || 'Not supplied'}`,
      'Please confirm module compatibility, final specification, price, availability and lead time before payment.'
    ].join('\n');
    error.hidden = activeOutputs > 0 || !attemptedSubmit;
  }
  function cartItems() {
    const colour = root.querySelector('input[name="brax_colour"]:checked')?.value || 'Black';
    const coreVariant = Number(colour === 'Silver' ? root.dataset.coreSilverVariant : root.dataset.coreBlackVariant);
    if (!coreVariant) throw new Error('The CORE is not available to add to cart right now.');
    const buildId = window.crypto?.randomUUID?.() || `brax-${Date.now()}`;
    const specification = [
      `CORE: ${colour}`,
      ...selected(inputs, 'Input'),
      ...selected(outputs, 'Output'),
      ...selected(becs, 'BEC')
    ].join('; ');
    const channelPairs = ['A/B', 'C/D', 'E/F', 'G/H', 'I/J', 'K/L'];
    const summaryFor = (list, type) => list.map((el, index) => el.value === 'None' ? '' : `${type} ${index + 1} (${channelPairs[index]}): ${el.value}`).filter(Boolean).join('; ');
    const inputSummary = summaryFor(inputs, 'Input');
    const outputSummary = summaryFor(outputs, 'Output');
    const becSummary = becs.map((el, index) => el.value === 'None' ? '' : `BEC ${index + 1}: ${el.value}`).filter(Boolean).join('; ');
    const items = [{ id: coreVariant, quantity: 1, properties: {
      'Build lead time': 'Typically 10 working days after specification agreement',
      'Input modules': inputSummary || 'None selected',
      'Output modules': outputSummary,
      'Extension cards': becSummary || 'None selected',
      _brax_builder_id: buildId,
      _brax_specification: specification,
      _brax_vehicle_source: vehicle.value.trim() || 'Not supplied',
      _brax_system_notes: notes.value.trim() || 'Not supplied'
    }}];
    for (const [list, type] of [[inputs, 'Input'], [outputs, 'Output'], [becs, 'BEC']]) {
      list.forEach((el, index) => {
        if (el.value === 'None') return;
        const option = el.selectedOptions[0];
        const id = Number(option.dataset.variantId);
        if (!id || componentPrices[id] !== pricePence(el)) throw new Error('A module price could not be verified. Please request advice instead.');
        const position = `${type} ${index + 1}${type === 'BEC' ? '' : ` · channels ${channelPairs[index]}`}`;
        items.push({ id, quantity: 1, properties: {
          'Assigned position': position,
          _brax_builder_id: buildId
        }});
      });
    }
    return items;
  }
  async function addToCart() {
    cartError.hidden = true;
    attemptedSubmit = true;
    render();
    if (outputs.every(el => el.value === 'None')) {
      outputs[0].focus();
      throw new Error('Choose at least one output module before adding your DSP to the cart.');
    }
    const items = cartItems();
    const expectedPence = Number(priceBox.dataset.corePricePence) + [...inputs, ...outputs, ...becs].reduce((sum, el) => sum + pricePence(el), 0);
    addCartButton.disabled = true;
    addCartButton.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated.');
      const actualPence = (result.items || []).reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0);
      if (actualPence !== expectedPence) throw new Error('The Shopify cart price differs from the builder. Please review your cart before checkout.');
      window.location.assign(window.routes?.cart_url || '/cart');
    } finally {
      addCartButton.disabled = false;
      addCartButton.removeAttribute('aria-busy');
    }
  }
  root.addEventListener('input', render);
  root.addEventListener('change', render);
  addCartButton.addEventListener('click', async function () {
    try { await addToCart(); }
    catch (problem) { cartError.textContent = problem.message || 'Could not add this build to the cart.'; cartError.hidden = false; }
  });
  const btKitButton = root.querySelector('[data-brax-bt-kit]');
  if (btKitButton) btKitButton.addEventListener('click', async function () {
    const kitError = root.querySelector('[data-brax-bt-kit-error]');
    kitError.hidden = true;
    btKitButton.disabled = true;
    try {
      const kitId = window.crypto?.randomUUID?.() || `bt-kit-${Date.now()}`;
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(btKitButton.dataset.streamerId), quantity: 1, properties: { Kit: 'BT HD STREAMER + hands-free microphone', _brax_accessory_kit_id: kitId } },
          { id: Number(btKitButton.dataset.microphoneId), quantity: 1, properties: { Kit: 'BT HD STREAMER + hands-free microphone', _brax_accessory_kit_id: kitId } }
        ] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'The kit could not be added.');
      const chargedPence = (result.items || []).reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0);
      if (chargedPence !== Number(btKitButton.dataset.kitPricePence)) throw new Error('The kit price changed. Please review your cart before checkout.');
      window.location.assign(window.routes?.cart_url || '/cart');
    } catch (problem) {
      kitError.textContent = problem.message || 'The kit could not be added.';
      kitError.hidden = false;
      btKitButton.disabled = false;
    }
  });
  form.addEventListener('submit', function (event) {
    render();
  });
  render();
});
